"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainScreen = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var doshx_controls_web_1 = require("doshx_controls_web");
var logo_png_1 = __importDefault(require("../assets/logo.png"));
// import { faFlame } from "@fortawesome/pro-solid-svg-icons";
var home_1 = require("./pages/home/home");
var about_us_1 = require("./pages/about_us");
var contact_us_1 = require("./pages/contact_us");
var shop_1 = require("./pages/shop/shop");
var basket_1 = require("./pages/basket/basket");
var log_in_1 = require("./pages/auth/log_in");
var sign_up_1 = require("./pages/auth/sign_up");
var profile_1 = require("./pages/profile/profile");
var react_redux_2 = require("react-redux");
var main_1 = require("../reducers/slices/main");
var product_1 = require("./pages/shop/product");
var checkout_1 = require("./pages/checkout");
var outcome_1 = require("./pages/outcome");
var user_1 = require("../reducers/slices/user");
var forgot_password_1 = require("./pages/forgot_password");
var search_products_1 = require("../api/calls/product/search_products");
var selection_1 = require("../reducers/slices/selection");
var getRootPath_1 = require("../helpers/getRootPath");
var universal_cookie_1 = __importDefault(require("universal-cookie"));
var orders_1 = require("./pages/orders/orders");
var details_1 = require("./pages/orders/details");
var terms_and_conditions_1 = require("./pages/terms_and_conditions");
var privacy_policy_1 = require("./pages/privacy_policy");
var get_basket_thunk_1 = require("../reducers/slices/basket/thunks/get_basket_thunk");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var hot_deals_1 = require("./pages/hot_deals");
var free_brands_svg_icons_1 = require("@fortawesome/free-brands-svg-icons");
var categories_1 = require("../api/calls/product/categories");
var application_1 = require("./pages/loans/application");
var advanced_personal_details_1 = require("./pages/advanced_personal_details/advanced_personal_details");
var employment_details_1 = require("./pages/employment_details/employment_details");
var loans_1 = require("./pages/loans/loans");
var details_2 = require("./pages/loans/details");
var publications_1 = require("./pages/news/publications");
var articles_1 = require("./pages/news/articles");
var article_1 = require("./pages/news/article");
var weather_1 = require("./pages/weather");
var wishlist_1 = require("./pages/wishlist");
var return_policy_1 = require("./pages/return_policy");
var affiliated_entities_1 = require("./pages/affiliated_entities");
var find_stores_1 = require("./pages/store/find-stores");
var view_store_1 = require("./pages/store/view_store");
var sign_in_required_1 = require("./pages/components/sign_in_required");
var live_chat_1 = require("./pages/live_chat");
var faqs_1 = require("./pages/faqs");
var route_names_1 = require("../constants/route_names");
var auth_1 = require("./pages/auth/auth");
var reset_password_1 = require("./pages/auth/reset_password");
var referral_1 = require("../referral");
var facetec_1 = require("./pages/auth/facetec");
var get__production_keys_1 = require("../api/calls/sky_api/get_ production_keys");
var Config_1 = require("../Config");
var FaceTecSDK_1 = require("../../core-sdk/FaceTecSDK.js/FaceTecSDK");
var sampleAppController_1 = require("../../facetec/src/sampleAppController");
var SampleAppUtilities_1 = require("../../facetec/src/utilities/SampleAppUtilities");
var ThemeHelpers_1 = require("../../facetec/src/utilities/ThemeHelpers");
var AdditionalScreens_1 = require("../../facetec/src/utilities/AdditionalScreens");
var DeveloperStatusMessages_1 = require("../../facetec/src/utilities/DeveloperStatusMessages");
var account_blocked_1 = require("./pages/auth/account_blocked");
var check_fraud_list_1 = require("../api/calls/user/authentication/check_fraud_list");
var check_duplicates_1 = require("../api/calls/user/authentication/check_duplicates");
var verifyEmail_1 = require("./pages/auth/verifyEmail");
var product_category_record_1 = __importDefault(require("./pages/home/product_category_record"));
var application_2 = require("./pages/lay_buys/application");
var lay_buys_1 = require("./pages/lay_buys/lay_buys");
var details_3 = require("./pages/lay_buys/details");
var jobs_1 = require("./pages/jobs/jobs");
var job_1 = require("./pages/jobs/job");
var general_1 = require("../helpers/general");
var NICEBOARD_ENABLED = process.env.FEATURE_NICEBOARD === "true";
var MainScreen = function () {
    var _a, _b, _c, _d, _e;
    var cookie = new universal_cookie_1.default();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var location = (0, react_router_dom_1.useLocation)();
    var rootPath = (0, getRootPath_1.getRootPath)(location);
    // const [drawerPageName, setDrawerPageName] = useState<"login" | "signup" | "forgot" | "profile">("login");
    var _f = (0, react_1.useState)(""), searchTerm = _f[0], setSearchTerm = _f[1];
    var _g = (0, react_1.useState)([]), searchPredictions = _g[0], setSearchPredictions = _g[1];
    var _h = (0, react_1.useState)(""), subscribingEmail = _h[0], setSubscribingEmail = _h[1];
    var _j = (0, react_1.useState)(""), subscribingEmailError = _j[0], setSubscribingEmailError = _j[1];
    var _k = (0, react_1.useState)(false), isBusySubscribing = _k[0], setIsBusySubscribing = _k[1];
    var _l = (0, react_1.useState)(false), userLoaded = _l[0], setUserLoaded = _l[1];
    var main = (0, react_redux_2.useSelector)(function (state) { return state.mainState; }).main;
    var user = (0, react_redux_2.useSelector)(function (state) { return state.userState; }).user;
    var basket = (0, react_redux_2.useSelector)(function (state) { return state.basketState; }).basket;
    var _m = (0, react_1.useState)(false), sdkInitialized = _m[0], setSdkInitialized = _m[1];
    var _o = (0, react_1.useState)(false), initAttempted = _o[0], setInitAttempted = _o[1];
    var _p = (0, react_1.useState)(false), previousAuthState = _p[0], setPreviousAuthState = _p[1];
    (0, react_1.useEffect)(function () {
        // Monitor authentication state changes and trigger hard refresh when user logs in
        var currentAuthState = !!(user === null || user === void 0 ? void 0 : user.uid);
        // Only trigger refresh if this is a new login (not on initial load)
        if (!previousAuthState && currentAuthState && userLoaded) {
            // Force a hard refresh to ensure user details are properly populated in the browser instance
            window.location.reload();
        }
        // Update the previous auth state
        setPreviousAuthState(currentAuthState);
    }, [user === null || user === void 0 ? void 0 : user.uid, previousAuthState, userLoaded]);
    var _q = (0, react_1.useState)([]), shopCategories = _q[0], setShopCategories = _q[1];
    (0, react_1.useEffect)(function () {
        var _a;
        // The dedicated referral route handles its own code and redirect flow.
        if (location.pathname === "/app/referral") {
            return;
        }
        var queryParams = new URLSearchParams(location.search);
        // "code" is the older share-link format — links already sent out still carry it.
        var referral = (_a = queryParams.get("referral_code")) !== null && _a !== void 0 ? _a : queryParams.get("code");
        if (referral) {
            dispatch((0, main_1.setDrawerPage)("signup"));
            dispatch((0, main_1.setDrawerOpen)(true));
        }
    }, [location.pathname, location.search, dispatch]);
    (0, react_1.useEffect)(function () {
        (0, get__production_keys_1.get_production_keys)({
            is_web: true,
        })
            .then(function (response) {
            var _a;
            if (response.success && ((_a = response.content) === null || _a === void 0 ? void 0 : _a.keys)) {
                var key = response.content.keys;
                Config_1.Config.ProductionKeyText = "{ \"domains\": \"".concat(key.domains, "\", \"expiryDate\": \"").concat(key.expiryDate, "\", \"key\": \"").concat(key.key, "\"}");
                Config_1.Config.DeviceKeyIdentifier = response.content.key_identifier;
                if (Config_1.Config.ProductionKeyText && Config_1.Config.DeviceKeyIdentifier) {
                    sampleAppController_1.SampleApp.ensureResourcesConfigured();
                    Config_1.Config.initializeFromAutogeneratedConfig(FaceTecSDK_1.FaceTecSDK, function (initializedSuccessfully) {
                        setInitAttempted(true);
                        setSdkInitialized(initializedSuccessfully);
                    }, Config_1.Config.ProductionKeyText, Config_1.Config.DeviceKeyIdentifier);
                }
                else {
                    setInitAttempted(true);
                    setSdkInitialized(false);
                }
            }
            else {
                setInitAttempted(true);
                setSdkInitialized(false);
            }
        })
            .catch(function () {
            setInitAttempted(true);
            setSdkInitialized(false);
        });
    }, [user.uid]);
    (0, react_1.useEffect)(function () {
        if (!initAttempted)
            return;
        if (sdkInitialized) {
            Config_1.Config.didSucceed = true;
            onFaceTecSDKInitializationSuccess();
        }
        else {
            Config_1.Config.didSucceed = false;
            onFaceTecSDKInitializationFailure();
        }
    }, [sdkInitialized, initAttempted]);
    (0, react_1.useEffect)(function () {
        if (user.uid) {
            setUserLoaded(true);
            if (!user.facetecDBRef || !user.facetec.authenticated) {
                navigate("/biometric/authentication");
            }
        }
    }, [user]);
    (0, react_1.useEffect)(function () {
        var timeoutId;
        if (user.uid) {
            var resetTimer_1 = function () {
                // Clear the existing timeout
                if (timeoutId)
                    clearTimeout(timeoutId);
                // Set a new timeout for 5 minutes (300,000 ms)
                timeoutId = setTimeout(function () {
                    // Log the user out after 5 minutes of inactivity
                    dispatch((0, user_1.sign_out_thunk)());
                    dispatch((0, main_1.setDrawerPage)("login"));
                    dispatch((0, main_1.setDrawerOpen)(true));
                    dispatch((0, main_1.setMessageModal)({ title: "Session Expired!", messages: ["Your session has expired due to inactivity. Please log in again to continue."] }));
                }, 300000); // 300000 ms = 5 minutes
            };
            // List of events that should reset the timer
            var events_1 = ["mousemove", "keydown", "mousedown", "touchstart"];
            // Attach the resetTimer function to all events
            events_1.forEach(function (event) { return window.addEventListener(event, resetTimer_1); });
            // Initial reset to start the timer when the component mounts
            resetTimer_1();
            // Cleanup event listeners on component unmount
            return function () {
                events_1.forEach(function (event) { return window.removeEventListener(event, resetTimer_1); });
                if (timeoutId)
                    clearTimeout(timeoutId);
            };
        }
    }, [user]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        //Get user in the cookie and set it in the store
        if (userLoaded && user) {
            if (!((_a = user === null || user === void 0 ? void 0 : user.location) === null || _a === void 0 ? void 0 : _a.lat) && !((_b = user === null || user === void 0 ? void 0 : user.location) === null || _b === void 0 ? void 0 : _b.lon) && navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    var newUserObj = __assign(__assign({}, user), { location: {
                            lat: position.coords.latitude,
                            lon: position.coords.longitude,
                        } });
                    dispatch((0, user_1.setUser)(newUserObj));
                }, function (error) {
                    console.error(error);
                });
            }
            else {
            }
        }
    }, [userLoaded]);
    (0, react_1.useEffect)(function () {
        //Get user in the cookie and set it in the store
        var userStateCookie = cookie.get("user_state");
        if (userStateCookie) {
            dispatch((0, user_1.setUser)(userStateCookie));
        }
    }, []);
    (0, react_1.useEffect)(function () {
        (0, categories_1.getCategories)({
            page: "1",
        }).then(function (response) {
            var categoryList = response.content.product_category_list;
            var newCategoryList = [];
            var _loop_1 = function (category) {
                if (product_category_record_1.default[category === null || category === void 0 ? void 0 : category._id] && category.description != "advert") {
                    newCategoryList.push({
                        label: category.name,
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            dispatch((0, selection_1.setSelectedCategory)({
                                item: {
                                    id: category._id,
                                    title: category.name,
                                    items: [],
                                },
                                level: 0,
                            }));
                            navigate("./shop/category/0/".concat(category._id, "/").concat(encodeURI(category.name)));
                        },
                    });
                }
            };
            for (var _i = 0, _a = categoryList !== null && categoryList !== void 0 ? categoryList : []; _i < _a.length; _i++) {
                var category = _a[_i];
                _loop_1(category);
            }
            setShopCategories(newCategoryList);
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (user === null || user === void 0 ? void 0 : user.uid) {
            dispatch((0, get_basket_thunk_1.get_basket_thunk)({ basket_id: "" }));
        }
    }, [user === null || user === void 0 ? void 0 : user.uid]);
    (0, react_1.useEffect)(function () {
        var delayFn = setTimeout(function () {
            if (searchTerm) {
                (0, search_products_1.searchProducts)({
                    search_string: searchTerm,
                }).then(function (response) {
                    setSearchPredictions(response.content);
                });
            }
        }, 777);
        return function () { return clearTimeout(delayFn); };
    }, [searchTerm]);
    var openAccountPage = function () {
        if (user === null || user === void 0 ? void 0 : user.uid) {
            dispatch((0, main_1.setDrawerPage)("profile"));
            // navigate(`${rootPath}/profile`);
        }
        else {
            dispatch((0, main_1.setDrawerPage)("login"));
            // navigate(`${location.pathname}/login`);
        }
        dispatch((0, main_1.setDrawerOpen)(true));
    };
    //Check if user if on blocked list or account duplicate
    var checkAccountStanding = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fraudList, duplicateAccount;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(user.uid && user.facetecDBRef)) return [3 /*break*/, 4];
                    return [4 /*yield*/, (0, check_fraud_list_1.check_fraud_list)({ externalDatabaseRefID: user.facetecDBRef, groupName: "FraudUserSearchList", minMatchLevel: 7 })];
                case 1:
                    fraudList = _b.sent();
                    if (!fraudList.content.isOnFraudList) return [3 /*break*/, 2];
                    navigate("/biometric/authentication/blocked");
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, check_duplicates_1.check_duplicates)({ externalDatabaseRefID: user.facetecDBRef })];
                case 3:
                    duplicateAccount = _b.sent();
                    if ((_a = duplicateAccount === null || duplicateAccount === void 0 ? void 0 : duplicateAccount.content) === null || _a === void 0 ? void 0 : _a.mainAccountEmail) {
                        dispatch((0, user_1.sign_out_thunk)());
                        dispatch((0, main_1.setMessageModal)({
                            title: "Account Duplicate!",
                            messages: [
                                "This is a duplicate account.",
                                "Please login with your password to an account with the email address (".concat(duplicateAccount.content.mainAccountEmail, ") to access your main account."),
                                "If this is not possible, please contact support.",
                            ],
                        }));
                    }
                    _b.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (user.uid && user.facetecDBRef) {
            checkAccountStanding();
        }
    }, [user.uid, user.facetecDBRef]);
    var TOP_BAR_ACTIONS = [
        {
            icon: pro_solid_svg_icons_1.faLocationDot,
            label: "Store Locations",
            onClick: function () {
                (0, general_1.scrollToTop)();
                navigate("/find-store");
            },
        },
        {
            icon: pro_solid_svg_icons_1.faHeart,
            label: "Wishlist",
            onClick: function () {
                (0, general_1.scrollToTop)();
                navigate("/wishlist");
            },
        },
    ];
    if (NICEBOARD_ENABLED) {
        TOP_BAR_ACTIONS.unshift({
            icon: pro_solid_svg_icons_1.faBriefcase,
            label: "Job Seekers",
            onClick: function () {
                (0, general_1.scrollToTop)();
                navigate("/jobs");
            },
        });
    }
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.TopHeaderControl, { logo: { image: logo_png_1.default, size: "small", onClick: function () { return navigate("/"); } }, search: {
                iconColor: "text-primary",
                displayKey: "label",
                options: searchPredictions
                    .filter(function (prediction) { return prediction.status === "AVAILABLE"; })
                    .map(function (prediction) { return ({
                    label: prediction.title,
                    value: prediction._id,
                }); }),
                searchChanged: function (value) {
                    setSearchTerm(value);
                },
                searchSelectionChanged: function (value) {
                    dispatch((0, selection_1.setSelectedProduct)({
                        _id: value.value,
                    }));
                    (0, general_1.scrollToTop)();
                    navigate("/product/".concat(value.value));
                },
            }, account: {
                displayText: (user === null || user === void 0 ? void 0 : user.uid) ? "".concat(user.name, " ").concat(user.surname) : undefined,
                iconColor: "text-white",
                backgroundColor: "bg-primary",
                onClick: function () {
                    // const strippedPath = getStrippedPath(location);
                    openAccountPage();
                },
            }, basket: {
                tooltip: {
                    label: "My Cart",
                    placement: "left-start",
                    colors: {
                        showShadow: true,
                        backgroundColor: "bg-primary",
                        textColor: "text-white",
                        borderColor: "border-primary",
                    },
                },
                count: (_b = (_a = basket === null || basket === void 0 ? void 0 : basket.product_list) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
                backgroundColor: "bg-primary",
                borderColor: "border-primary",
                size: "large",
                countTextColor: "text-white",
                countBackgroundColor: "bg-secondary",
                iconColor: "text-white",
                onClick: function () {
                    (0, general_1.scrollToTop)();
                    navigate("/basket");
                },
            }, topBar: {
                colors: {
                    textColor: "text-white",
                    backgroundColor: "bg-secondary",
                    actions: {
                        iconColor: "text-white",
                        textColor: "text-white",
                        backgroundColor: "bg-primary",
                        underlineColor: "decoration-primary",
                    },
                },
                contactNumber: (_c = process.env.CONTACT_SUPPORT_PHONE_NUMBER) !== null && _c !== void 0 ? _c : "",
                contactEmail: process.env.CONTACT_SUPPORT_EMAIL_ADDRESS,
                actions: TOP_BAR_ACTIONS,
            }, menu: {
                menuItems: [
                    {
                        label: "Home",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/home");
                        },
                    },
                    {
                        label: "About Us",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/about-us");
                        },
                    },
                    {
                        label: "Loans",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/loans");
                        },
                    },
                    {
                        label: "Lay-buys",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/lay-buys");
                        },
                    },
                    {
                        label: "Shop",
                        subItems: shopCategories,
                    },
                    {
                        label: "Affiliated Entities",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/affiliated-entities");
                        },
                    },
                    {
                        label: "FAQs",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/faqs");
                        },
                    },
                    {
                        label: "Contact Us",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/contact-us");
                        },
                    },
                ],
            } }),
        react_1.default.createElement(doshx_controls_web_1.DrawerControl, { open: main.isDrawerOpen, close: {
                backgroundColor: "bg-primary",
            }, toggleOpen: function (v) {
                dispatch((0, main_1.setDrawerOpen)(v));
            } }, (function () {
            switch (main.drawerPageName) {
                case "login":
                    return react_1.default.createElement(log_in_1.SignInPage, null);
                case "signup":
                    return react_1.default.createElement(sign_up_1.SignUpPage, null);
                case "profile":
                    return react_1.default.createElement(profile_1.ProfilePage, null);
                case "forgot":
                    return react_1.default.createElement(forgot_password_1.ForgotPasswordPage, null);
            }
        })()),
        react_1.default.createElement("div", { className: "pt-5 pb-10" },
            react_1.default.createElement(react_router_dom_1.Routes, null,
                react_1.default.createElement(react_router_dom_1.Route, { index: true, element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "/home" }) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/home/*", element: react_1.default.createElement(home_1.HomePage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/about-us/*", element: react_1.default.createElement(about_us_1.AboutUsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/contact-us/*", element: react_1.default.createElement(contact_us_1.ContactUsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/shop/*", element: react_1.default.createElement(shop_1.ShopPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/product/:productId", element: react_1.default.createElement(product_1.ProductPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/basket/*", element: react_1.default.createElement(basket_1.BasketPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/hot-deals/*", element: react_1.default.createElement(hot_deals_1.HotDealsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/terms-and-conditions/*", element: react_1.default.createElement(terms_and_conditions_1.TermsAndConditionsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/privacy-policy/*", element: react_1.default.createElement(privacy_policy_1.PrivacyPolicyPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/return-policy/*", element: react_1.default.createElement(return_policy_1.ReturnPolicyPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/affiliated-entities", element: react_1.default.createElement(affiliated_entities_1.AffiliatedEntitiesPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/find-store", element: react_1.default.createElement(find_stores_1.FindStoresPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/view-store/:storeID", element: react_1.default.createElement(view_store_1.ViewStorePage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/publications", element: react_1.default.createElement(publications_1.PublicationsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/articles/:publication_id", element: react_1.default.createElement(articles_1.ArticlesPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/article/:publication_id/:id", element: react_1.default.createElement(article_1.ArticlePage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/weather", element: react_1.default.createElement(weather_1.WeatherPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/faqs", element: react_1.default.createElement(faqs_1.FAQsPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/app/referral", element: react_1.default.createElement(referral_1.ReferralPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/outcome/:actionType", element: react_1.default.createElement(outcome_1.OutcomePage, null) }),
                NICEBOARD_ENABLED && react_1.default.createElement(react_router_dom_1.Route, { path: "/jobs", element: react_1.default.createElement(jobs_1.JobsPage, null) }),
                NICEBOARD_ENABLED && react_1.default.createElement(react_router_dom_1.Route, { path: "/job/:job_id", element: react_1.default.createElement(job_1.JobPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/firebase/auth/:actionData", element: react_1.default.createElement(auth_1.FirebaseAuthRedirectPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/auth/password/reset/:resetCode", element: react_1.default.createElement(reset_password_1.ResetPasswordPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/auth/verify/email/:resetCode", element: react_1.default.createElement(verifyEmail_1.VerifyEmailPage, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { element: user.uid && !((_d = user === null || user === void 0 ? void 0 : user.facetec) === null || _d === void 0 ? void 0 : _d.authenticated) ? react_1.default.createElement(facetec_1.FaceTecApp, null) : "" },
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/checkout/:payment?", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(checkout_1.CheckoutPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/orders", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(orders_1.OrdersPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/chat", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(live_chat_1.LiveChatPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/order/details/:orderId", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(details_1.OrderDetailsPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "".concat(route_names_1.ROUTE_LOAN_APPLICATION, "/:step/:loan_id"), element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(application_1.LoanApplicationPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "".concat(route_names_1.ROUTE_LAYBUY_APPLICATION, "/:step/:laybuy_id"), element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(application_2.LaybuyApplicationPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/loan/details/:loan_id", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(details_2.LoanDetailsPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/loans", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(loans_1.LoansPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/lay-buy/details/:laybuy_id", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(details_3.LaybuyDetailsPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/lay-buys", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(lay_buys_1.LaybuysPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/wishlist", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(wishlist_1.WishListPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/advanced-personal-details/*", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(advanced_personal_details_1.AdvancedPersonalDetailsPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                    react_1.default.createElement(react_router_dom_1.Route, { path: "/employment-details/*", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(employment_details_1.EmploymentDetailsPage, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) })),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/biometric/authentication", element: (0, user_1.isAuthenticated)() ? react_1.default.createElement(facetec_1.FaceTecApp, null) : react_1.default.createElement(sign_in_required_1.SignInRequiredComponent, null) }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/biometric/authentication/blocked", element: react_1.default.createElement(account_blocked_1.FaceTecAppBlocked, null) }))),
        react_1.default.createElement("div", { className: "w-full h-16 bg-primary" }),
        react_1.default.createElement(doshx_controls_web_1.FooterControl, { backgroundColor: "bg-white", 
            // newsletter={{
            //   title: "Sign up for our newsletter",
            //   description: "Join our newsletter community and never miss a beat.",
            //   backgroundColor: "bg-primary",
            //     textColor: "text-white",
            //   onEmailChange: (v) => setSubscribingEmail(v),
            //   emailAddress: subscribingEmail,
            //   input: {
            //     errorText: subscribingEmailError,
            //   },
            //   button: {
            //     backgroundColor: "bg-primary",
            //     loading: isBusySubscribing,
            //     onClick: () => {
            //       setSubscribingEmailError("");
            //       if (!subscribingEmail) {
            //         setSubscribingEmailError("Please enter a valid email address.");
            //       } else {
            //         setIsBusySubscribing(true);
            //         newsletter_subscribe({
            //           email: subscribingEmail,
            //         }).then((response: any) => {
            //           setIsBusySubscribing(false);
            //           if (response.success) {
            //             setSubscribingEmail("");
            //             dispatch(setMessageModal({ title: "Subscribed!", messages: ["You have successfully subscribed to our newsletter!"] }));
            //           } else {
            //             dispatch(setMessageModal({ title: "Something went wrong!", messages: [response.message] }));
            //           }
            //         });
            //       }
            //     },
            //   },
            // }}
            logo: {
                image: logo_png_1.default,
                size: "medium",
            }, description: "", socialMedia: [
                // {
                //   icon: faYoutube,
                //   backgroundColor: "bg-gray-200",
                //   onClick() {
                //     window.open("", "_blank");
                //   },
                // },
                // {
                //   icon: faLinkedinIn,
                //   backgroundColor: "bg-gray-200",
                //   onClick() {
                //     window.open("", "_blank");
                //   },
                // },
                {
                    icon: free_brands_svg_icons_1.faFacebook,
                    backgroundColor: "bg-gray-200",
                    onClick: function () {
                        window.open("https://facebook.com/TheSkyLifeStyleNamibia", "_blank");
                    },
                },
                // {
                //   icon: faTwitter,
                //   backgroundColor: "bg-gray-200",
                //   onClick() {
                //     window.open("", "_blank");
                //   },
                // },
                // {
                //   icon: faInstagram,
                //   backgroundColor: "bg-gray-200",
                //   onClick() {
                //     window.open("", "_blank");
                //   },
                // },
            ], shortcut: {
                links: [
                    {
                        label: "About Us",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/about-us");
                        },
                    },
                    {
                        label: "Affiliated Entities",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/affiliated-entities");
                        },
                    },
                    {
                        label: "Contact Us",
                        onClick: function () {
                            (0, general_1.scrollToTop)();
                            navigate("/contact-us");
                        },
                    },
                    {
                        label: "Terms and Conditions",
                        onClick: function () {
                            var link = document.createElement("a");
                            link.href = "/docs/SKY_APP_TERMS_AND_CONDITIONS.pdf";
                            link.target = "_blank"; // Open in a new tab
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link); // Remove the element after opening
                        },
                    },
                    {
                        label: "Privacy Policy",
                        onClick: function () {
                            navigate("/privacy-policy");
                            // const link = document.createElement("a");
                            // link.href = `/docs/SKY_APP_PRIVACY_POLICY.pdf`;
                            // link.target = "_blank"; // Open in a new tab
                            // document.body.appendChild(link);
                            // link.click();
                            // document.body.removeChild(link); // Remove the element after opening
                        },
                    },
                    {
                        label: "Return Policy",
                        onClick: function () {
                            var link = document.createElement("a");
                            link.href = "/docs/SKY_APP_RETURN_POLICY.pdf";
                            link.target = "_blank"; // Open in a new tab
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link); // Remove the element after opening
                        },
                    },
                    {
                        label: "Cookie Policy",
                        onClick: function () {
                            var link = document.createElement("a");
                            link.href = "/docs/SKY_APP_COOKIE_POLICY.pdf";
                            link.target = "_blank"; // Open in a new tab
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link); // Remove the element after opening
                        },
                    },
                    {
                        label: "Authorization for Electronic Payments",
                        onClick: function () {
                            var link = document.createElement("a");
                            link.href = "/docs/AUTHORIZATION_FOR_ELECTRONIC_PAYMENTS.pdf";
                            link.target = "_blank"; // Open in a new tab
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link); // Remove the element after opening
                        },
                    },
                ],
            }, customer: {
                title: "Customer Links",
                links: (user === null || user === void 0 ? void 0 : user.uid)
                    ? [
                        { label: "My Account", onClick: function () { return openAccountPage(); } },
                        {
                            label: "Order History",
                            onClick: function () {
                                (0, general_1.scrollToTop)();
                                navigate("/orders");
                            },
                        },
                        {
                            label: "Loans",
                            onClick: function () {
                                (0, general_1.scrollToTop)();
                                navigate("/loans");
                            },
                        },
                        {
                            label: "Wishlist",
                            onClick: function () {
                                (0, general_1.scrollToTop)();
                                navigate("/wishlist");
                            },
                        },
                        // {
                        //   label: "Live Chat",
                        //   onClick: () => {
                        //     scrollToTop();
                        //     navigate("/chat");
                        //   },
                        // },
                        //
                    ]
                    : [
                        {
                            label: "Login",
                            onClick: function () {
                                dispatch((0, main_1.setDrawerPage)("login"));
                                dispatch((0, main_1.setDrawerOpen)(true));
                            },
                        },
                        {
                            label: "Sign Up",
                            onClick: function () {
                                dispatch((0, main_1.setDrawerPage)("signup"));
                                dispatch((0, main_1.setDrawerOpen)(true));
                            },
                        },
                    ],
            }, contact: {
                title: "Contact",
                description: "Need assistance or have a question? Contact us and we'll be happy to help!",
                phone: {
                    number: (_e = process.env.CONTACT_SUPPORT_PHONE_NUMBER) !== null && _e !== void 0 ? _e : "",
                    icon: pro_solid_svg_icons_1.faPhoneSquare,
                    title: "Have any questions?",
                    onClick: function () { },
                },
                email: {
                    address: "".concat(process.env.CONTACT_SUPPORT_EMAIL_ADDRESS),
                    icon: pro_solid_svg_icons_1.faEnvelopeSquare,
                    title: "Want to send us a message?",
                    onClick: function () {
                        window.open("mailto:".concat(process.env.CONTACT_SUPPORT_EMAIL_ADDRESS, "?subject=Website Enquiry"), "_blank");
                    },
                },
            }, copyright: { company: "Let'sTrade", textColor: "text-black", backgroundColor: "bg-gray-200" } }),
        main.messageModal && (react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: main.messageModal.title, open: true, onClose: function () {
                // setIsOpen(false);
                dispatch((0, main_1.setMessageModal)(null));
            } },
            react_1.default.createElement("div", { className: "p-4" }, main.messageModal.messages.map(function (message, index) {
                return react_1.default.createElement("div", { key: "modal-message-".concat(index) }, message);
            })))),
        main.contentModal && (react_1.default.createElement(doshx_controls_web_1.ModalControl, { title: main.contentModal.title, open: true, onClose: function () {
                // setIsOpen(false);
                dispatch((0, main_1.setContentModal)(null));
            } },
            react_1.default.createElement("div", { className: "p-4" }, main.contentModal.content)))));
};
exports.MainScreen = MainScreen;
function onFaceTecSDKInitializationSuccess() {
    SampleAppUtilities_1.SampleAppUtilities.enableControlButtons();
    ThemeHelpers_1.ThemeHelpers.setAppTheme(ThemeHelpers_1.ThemeHelpers.getCurrentTheme());
    SampleAppUtilities_1.SampleAppUtilities.setVocalGuidanceSoundFiles();
    SampleAppUtilities_1.SampleAppUtilities.setOCRLocalization();
    if (document.getElementById("controls") !== null) {
        AdditionalScreens_1.AdditionalScreens.setServerUpgradeStyling(document.getElementById("controls"), exitAdditionalScreen);
    }
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
}
function onFaceTecSDKInitializationFailure() {
    DeveloperStatusMessages_1.DeveloperStatusMessages.logInitializeResult();
}
function exitAdditionalScreen() {
    AdditionalScreens_1.AdditionalScreens.exitAdditionalScreen(SampleAppUtilities_1.SampleAppUtilities.showMainUI);
}
